<ng-container *ngIf="showNumber; else noNumberBadge">
   <ng-container *ngTemplateOutlet="badgeWithNumber"></ng-container>
</ng-container>

<ng-template #noNumberBadge>
   <div class="badge-without-number">
      <kendo-badge-container class="badge-without-number">
         <kendo-badge class="badge-without-number"></kendo-badge>
      </kendo-badge-container>
   </div>
</ng-template>

<ng-template #badgeWithNumber>
   <div class="badge-with-number">
      <kendo-badge-container>
         <kendo-badge>{{ numberOfUnreadMessages }}</kendo-badge>
      </kendo-badge-container>
   </div>
</ng-template>
